<template>
  <div>
    <!-- Label -->
    <v-row>
      <v-col cols="12">
        <v-row>
          <v-col>
            <v-menu>
              <template v-slot:activator="{ on: menu, attrs }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="primary"
                      dark
                      v-bind="attrs"
                      v-on="{ on, ...menu }"
                    >
                      {{ field.label }}
                    </v-btn>
                  </template>
                  <span>{{ field.label }}</span>
                </v-tooltip>
              </template>

              <v-list v-if="field.valueFilter">
                <v-list-item v-for="(item, index) in fieldValues" :key="index">
                  <v-checkbox v-model="item.checked"></v-checkbox>
                  <v-list-item-title>{{ item.value }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- Settings dropdown -->
    <div class="field-dropdown-menu" v-if="hasDropdown" v-show="showDropdown">
      <!-- Headers filter -->
      <template v-if="field.headerAttributeFilter">
        <h6 class="dropdown-header">Attributes</h6>
        <div class="dropdown-list px-4 py-2">
          <div
            class="mb-1"
            v-for="(header, index) in field.headers"
            :key="index"
          >
            <div class="custom-control custom-checkbox">
              <input
                type="checkbox"
                class="custom-control-input"
                :id="`checkbox-${field.key}-header-${index}`"
                v-model="header.checked"
              />
              <label
                class="custom-control-label"
                :for="`checkbox-${field.key}-header-${index}`"
              >
                {{ header.label }}
              </label>
            </div>
          </div>
        </div>
      </template>

      <div
        class="dropdown-divider"
        v-if="field.headerAttributeFilter && field.valueFilter"
      ></div>

      <!-- Values filter -->
      <template v-if="field.valueFilter">
        <h6 class="dropdown-header">Values</h6>
        <div
          class="dropdown-item"
          style="cursor: pointer"
          @click="toggleAllValues(!allValuesSelected)"
        >
          <template v-if="allValuesSelected">
            <v-col> Unselect all </v-col>
          </template>
          <template v-else>
            <v-col>Select all</v-col>
          </template>
        </div>
        <div class="dropdown-list px-4 py-2">
          <div class="mb-1" v-for="(item, index) in fieldValues" :key="index">
            <div class="custom-control custom-checkbox">
              <input
                type="checkbox"
                class="custom-control-input"
                :id="`checkbox-${field.key}-value-${index}`"
                v-model="item.checked"
              />
              <label
                class="custom-control-label"
                :for="`checkbox-${field.key}-value-${index}`"
              >
                <slot
                  v-if="field.valueFilterSlotName"
                  :name="field.valueFilterSlotName"
                  v-bind:value="item.value"
                >
                  Missing slot <code>{{ field.valueFilterSlotName }}</code>
                </slot>
                <template v-else>
                  {{ item.value }}
                </template>
              </label>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: "fieldValues",
  },
  props: {
    fieldValues: {
      type: Array,
    },
    field: {
      type: Object,
    },
  },
  data() {
    return {
      showDropdown: false,
    };
  },
  computed: {
    hasDropdown() {
      return (
        (this.field.headerAttributeFilter && this.field.headers) ||
        this.field.valueFilter
      );
    },
    allValuesSelected() {
      let allValuesSelected = true;

      for (let valueObject of this.fieldValues) {
        if (!valueObject.checked) {
          allValuesSelected = false;
          break;
        }
      }

      return allValuesSelected;
    },
  },
  methods: {
    toggleShowDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    toggleAllValues(target) {
      this.fieldValues.forEach((valueObject) => {
        valueObject.checked = target;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/* Grid with gutter */
.gutter-x-sm,
.gutter-sm {
  margin-left: -0.5rem;
  > * {
    margin-left: 0.5rem;
  }
}
